var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('modal', {
    attrs: {
      "title": _vm.modalTitle,
      "persistent": "",
      "show-close-button": false,
      "mobile-fullscreen": false,
      "closeable": false,
      "button-break-column": "xs"
    },
    model: {
      value: _vm.isActive,
      callback: function ($$v) {
        _vm.isActive = $$v;
      },
      expression: "isActive"
    }
  }, [_vm.currentContent === 'settings' ? [_vm.text.custom_content ? _c('p', {
    staticClass: "text-sm"
  }, [_vm._v(_vm._s(_vm.text.custom_content))]) : _vm._e(), _vm._v(" "), _vm._l(_vm.cookies, function (cookie, key) {
    return _c('div', {
      key: key,
      staticClass: "py-24",
      class: {
        'border-b': key < _vm.cookies.length - 1
      }
    }, [_c('div', [_c('form-switch', {
      attrs: {
        "disabled": cookie.disabled,
        "value": cookie.value,
        "on-text": false,
        "off-text": false
      },
      on: {
        "input": cookie.handler
      }
    }, [_c('span', {
      staticClass: "flex flex-column"
    }, [cookie.title ? _c('span', {
      staticClass: "font-bold text-sm mb-3"
    }, [_vm._v(_vm._s(cookie.title))]) : _vm._e(), _vm._v(" "), cookie.text ? _c('span', {
      staticClass: "text-sm leading-tight"
    }, [_vm._v(_vm._s(cookie.text))]) : _vm._e(), _vm._v(" "), _c('span', [_vm.visibleCookies !== key ? _c('btn', {
      staticClass: "pl-0",
      attrs: {
        "plain": "",
        "small": "",
        "color": "primary"
      },
      on: {
        "click": function ($event) {
          _vm.visibleCookies = key;
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('cookie_banner.show_cookies')))]) : _c('btn', {
      staticClass: "pl-0",
      attrs: {
        "plain": "",
        "small": "",
        "color": "primary"
      },
      on: {
        "click": function ($event) {
          _vm.visibleCookies = null;
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('cookie_banner.hide_cookies')))])], 1)])]), _vm._v(" "), _vm.visibleCookies === key ? _c('info-list', {
      staticClass: "ml-64",
      attrs: {
        "x-small": ""
      }
    }, _vm._l(cookie.cookies, function (cookieItem, cookieItemKey) {
      return _c('info-list-item', {
        key: cookieItemKey,
        attrs: {
          "icon": false
        }
      }, [_c('span', {
        staticClass: "flex flex-column"
      }, [_c('b', [_vm._v(_vm._s(cookieItem.title) + ":")]), _vm._v(" "), _c('span', {
        domProps: {
          "innerHTML": _vm._s(cookieItem.text)
        }
      })])]);
    }), 1) : _vm._e()], 1)]);
  })] : _vm.currentContent === 'privacy' ? _c('server-content', {
    attrs: {
      "action": _vm.$api('settings.show', 'privacy'),
      "data": {
        _guest: true
      },
      "access": "value"
    }
  }) : _vm.currentContent === 'imprint' ? _c('server-content', {
    attrs: {
      "action": _vm.$api('settings.show', 'imprint'),
      "data": {
        _guest: true
      },
      "access": "value"
    }
  }) : _vm.text.content ? _c('p', {
    staticClass: "text-sm mb-0"
  }, [_vm._v(_vm._s(_vm.text.content))]) : _vm._e(), _vm._v(" "), !_vm.currentContent || _vm.currentContent === 'settings' ? _c('wrapper', {
    staticClass: "my-8",
    attrs: {
      "slot": "footer",
      "center": ""
    },
    slot: "footer"
  }, [_c('btn', {
    staticClass: "text-gray-450 hover:text-primary",
    attrs: {
      "x-small": "",
      "plain": ""
    },
    on: {
      "click": function ($event) {
        return _vm.showContent('privacy');
      }
    }
  }, [_vm._v(_vm._s(_vm.text.privacy))]), _vm._v(" "), _c('btn', {
    staticClass: "text-gray-450 hover:text-primary",
    attrs: {
      "x-small": "",
      "plain": ""
    },
    on: {
      "click": function ($event) {
        return _vm.showContent('imprint');
      }
    }
  }, [_vm._v(_vm._s(_vm.text.imprint))])], 1) : _vm._e(), _vm._v(" "), _c('template', {
    slot: "button"
  }, [_vm.currentContent ? _c('btn', {
    attrs: {
      "large": ""
    },
    on: {
      "click": _vm.hideMoreInfo
    }
  }, [_c('icon', {
    attrs: {
      "icon": _vm.$icons.back
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.text.back))])], 1) : _c('btn', {
    attrs: {
      "large": ""
    },
    on: {
      "click": function ($event) {
        return _vm.showContent('settings');
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.text.settings))])]), _vm._v(" "), _c('btn', {
    attrs: {
      "color": "success",
      "large": ""
    },
    on: {
      "click": _vm.accept
    }
  }, [_c('icon', {
    attrs: {
      "icon": _vm.$icons.check
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.text.accept))])], 1)], 1)], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }